import ImageItem from './imageItem.js';
import withMagnified from '../hoc/withMagnified.js';
export default withMagnified(ImageItem);
//# sourceMappingURL=imageWithMagnified.js.map